import { render, staticRenderFns } from "./civilOrder4.vue?vue&type=template&id=cca604bc&scoped=true&"
import script from "./civilOrder4.vue?vue&type=script&lang=js&"
export * from "./civilOrder4.vue?vue&type=script&lang=js&"
import style0 from "./civilOrder4.vue?vue&type=style&index=0&id=cca604bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca604bc",
  null
  
)

export default component.exports